// @ts-nocheck
/* eslint-disable */
import MyMapsPopup from "~/es6/mymaps.popup";
import { Provider, Notifications } from "~/photo/globals";
import { _ } from "~/i18n";
import { node } from "~/util/dom";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";

export default class DeletePopup {
	constructor(cb) {
		this._data = null;
		this._cancelState = false;

		this._cb = cb;

		this._popup = new MyMapsPopup({
			name: "photo-delete",
			cb: event => {
				if (event.name === "close" && !this._cancelState) {
					let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
					let logData = { text: "deleteClose" };

					if (Mapy.getComponent("photoDetail").isActive()) {
						logData.place = "detail";
						logData.galleryType = galleryData?.galleryType ? galleryData.galleryType : "photomap";
						logData.section = "gallery";
					}

					Mapy.getComponent("logger").log("click", Object.assign(galleryData || {}, logData));
				}

				this._cb(event);
			},
		});

		this._node = this._popup.getContainer();
	}

	destroy() {
		this._node = null;
		this._popup.destroy();
	}

	open(data) {
		this._data = data;
		this._build();
		this._popup.open();
		this._popup.closeButton.setAttribute("data-log-ignore", "1");
	}

	close() {
		this._data = null;
		this._popup.close();
		this._cancelState = false;
	}

	handleEvent(event) {
		if (event.target == this._saveBtn) {
			event.stopPropagation();

			let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
			let logData = { text: _("photo.delete") };

			if (Mapy.getComponent("photoDetail").isActive()) {
				logData.place = "detail";
				logData.galleryType = galleryData.galleryType ? galleryData.galleryType : "photomap";
			}

			Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

			this._delete();
		}
		else if (event.target == this._cancelBtn) {
			event.stopPropagation();

			let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
			let logData = { text: _("cancel") };

			if (Mapy.getComponent("photoDetail").isActive()) {
				logData.place = "detail";
				logData.galleryType = galleryData.galleryType ? galleryData.galleryType : "photomap";
			}

			Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

			this._cancelState = true;

			this._cb({ name: "cancel" });
		}
	}

	/**
	 * Vytvoreni popupu pro odebrani.
	 */
	_build() {
		let header = node("h2", { className: "header" }, this._data.my ? _("photo.delete.title3") : _("photo.delete.title"));
		let name = node("h3", { className: "name" }, this._data.title);
		let content = node("div", { className: "content" });
		let hint = node("p");
		let buttons = node("div", { className: "buttons" });
		let saveBtn = node("button", { className: "save" }, _("photo.delete"));
		saveBtn.setAttribute("type", "button");
		saveBtn.setAttribute("data-log-ignore", "1");
		let cancelBtn = node("button", { className: "cancel", textContent: _("cancel") });
		cancelBtn.setAttribute("type", "button");
		cancelBtn.setAttribute("data-log-ignore", "1");

		let image = new Image();
		image.crossOrigin = "anonymous";
		image.src = this._data.url300;
		image.alt = this._data.title;
		content.appendChild(image);

		buttons.appendChild(saveBtn);
		buttons.appendChild(cancelBtn);

		hint.innerHTML = _("photo.delete.hint");

		this._node.appendChild(header);
		this._node.appendChild(content);
		if (this._data.title && this._data.title != "") {
			this._node.appendChild(name);
		}
		this._node.appendChild(hint);
		this._node.appendChild(buttons);

		saveBtn.addEventListener("click", this, false);
		cancelBtn.addEventListener("click", this, false);

		this._saveBtn = saveBtn;
		this._cancelBtn = cancelBtn;
	}

	_delete() {
		let my = this._data.my;
		let updateProm = Provider.mediaDel(this._data.id, this._data.source == "ffoto");
		this._saveBtn.disabled = true;

		updateProm.then(response => {
			this._saveBtn.disabled = false;
			this._cb({ name: "photo-delete" });

			Notifications.notify({
				content: my ? _("mymap.places.remove.photo2") : _("mymap.places.remove.photo"),
				type: NOTIFICATIONS_TYPE.SUCCESS,
			});
		}, e => {
			this._saveBtn.disabled = false;
			Notifications.notify({
				content: _("mymap.places.errorRemove"),
				type: NOTIFICATIONS_TYPE.ERROR,
			});
			// eslint-disable-next-line no-console
			console.error(e);
		});
	}
}
